import { InfoWindow, Polyline } from "@react-google-maps/api";
import { useEffect, useState } from "react";
import Walking_Img from '../../../../assets/img/walk.png';
import "./polyline-css.scss"
const PolylineRoute = (props: any) => {
  const symbolOne = {
    path: props?.Symbol,
    strokeOpacity: 1,
    scale: props?.scale,
    fillOpacity: 1,
  };
  const [tooltip, setTooltip] = useState<any>(null);
  const [RouteVal, setRouteVals] = useState<any>([props.RouteValues]);
  const [RouteLine, setRouteLine] = useState([]);
  const handleMouseOver = (e: any) => {
    setTooltip({
      position: e.latLng,
      text: props.RouteNames,
    });
  };

  const handleMouseOut = () => {
    setTooltip(null);
  };
  useEffect(() => {
    let temp_route_design: any = [];
    props.RouteValues.map((val: any) => {
      temp_route_design.push({
        icon: symbolOne,
        offset: "10px",
        repeat: props.repeat,
        geodesic: true,
      });
    });
    setRouteVals(props.RouteValues);
    setRouteLine(temp_route_design);
  }, [props.RouteValues]);
  const TooltipContent = ({ text }: any) => {
    let temp_flag_img:any = text;
    if(text == "Path"){
      temp_flag_img = <img src={Walking_Img} height="20px" alt="Path"></img>;
    }
    return <div style={{ padding: "3px", fontSize: "10px" }}>
     {temp_flag_img}
    </div>
  }
  return (
    <>
      <Polyline
        path={RouteVal}
        onMouseOver={handleMouseOver}
        onMouseOut={handleMouseOut}
        options={{
          strokeColor: props.colorRoute,
          strokeOpacity: props.isJoint,
          strokeWeight: 2.7,
          icons: RouteLine,
        }}
      />
      {tooltip && (
        <InfoWindow position={tooltip.position} onCloseClick={handleMouseOut}>
          <TooltipContent text={tooltip.text} />
        </InfoWindow>
      )}
    </>
  );
};

export default PolylineRoute;
